import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const I18N_NAMESPACE = '@mc/guest-pass'

export const i18nInstance = registerI18nResources({
  namespace: I18N_NAMESPACE,
  resources: {
    'en-US': enUS, // always load 'en-US' for fallback
  },
})

export default i18nInstance
